import { TERMINE_TERMIN_KALENDER_CREATE } from '@/domain/termine/hooks/graphql/mutation';
import {
  MarkierungType,
  toGraphQLMarkierung,
} from '@/domain/termine/shared/types/Markierung';
import {
  Termine_TerminKalenderCreateInput,
  Termine_TerminKalenderCreateResponse,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';

type CreateTerminKalenderProps = {
  name: string;
  markierung: MarkierungType;
  standortId: string;
};

export function useCreateTerminKalender() {
  const [mutate, { loading }] = useMutation<
    { termine_terminKalenderCreate: Termine_TerminKalenderCreateResponse },
    { input: Termine_TerminKalenderCreateInput }
  >(TERMINE_TERMIN_KALENDER_CREATE, {
    refetchQueries: [
      'GetTagesDaten',
      'GetTermineKalenderByStandortIdAndZeitraum',
    ],
    awaitRefetchQueries: true,
  });

  const createTerminKalender = async (props: CreateTerminKalenderProps) => {
    const result = await mutate({
      variables: {
        input: {
          name: props.name,
          markierung: toGraphQLMarkierung(props.markierung),
          standortId: props.standortId,
        },
      },
    });
    return result.data?.termine_terminKalenderCreate;
  };

  return {
    createTerminKalender,
    loading,
  };
}
